var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "installment-factoid"
  }, [_c('h4', {
    staticClass: "installment-factoid__title"
  }, [_vm._v("\n    Все товары 05.ru можно купить в рассрочку\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('GGLink', {
    staticClass: "installment-factoid__button cc-link cc-link_wu",
    attrs: {
      "to": "/about/rassrochka/"
    }
  }, [_c('button', {
    staticClass: "installment-factoid__button-el"
  }, [_vm._v("Расcчитать условия")])]), _vm._v(" "), _vm._m(2)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "installment-factoid__terms"
  }, [_c('div', {
    staticClass: "installment-factoid__terms-header"
  }, [_c('h5', {
    staticClass: "installment-factoid__subtitle"
  }, [_vm._v("ТНВ «Ляриба-Финанс»")]), _vm._v(" "), _c('img', {
    staticClass: "installment-factoid__terms-img ml-13",
    attrs: {
      "src": require("./asset/lariba.png"),
      "alt": "логотип LaRiba"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "installment-factoid__terms-list"
  }, [_c('li', {
    staticClass: "installment-factoid__term"
  }, [_c('span', {
    staticClass: "installment-factoid__term-title"
  }, [_vm._v("Первый взнос:")]), _vm._v(" "), _c('p', {
    staticClass: "installment-factoid__term-text b"
  }, [_vm._v("от 25%")])]), _vm._v(" "), _c('li', {
    staticClass: "installment-factoid__term"
  }, [_c('span', {
    staticClass: "installment-factoid__term-title"
  }, [_vm._v("Возраст:")]), _vm._v(" "), _c('p', {
    staticClass: "installment-factoid__term-text b"
  }, [_vm._v("от 23 лет")])]), _vm._v(" "), _c('li', {
    staticClass: "installment-factoid__term"
  }, [_c('span', {
    staticClass: "installment-factoid__term-title"
  }, [_vm._v("Наценка:")]), _vm._v(" "), _c('p', {
    staticClass: "installment-factoid__term-text b"
  }, [_vm._v("2,4% – 3.75%")])])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "installment-factoid__term"
  }, [_c('span', {
    staticClass: "installment-factoid__term-title"
  }, [_vm._v("Наш телефон:")]), _vm._v(" "), _c('a', {
    staticClass: "installment-factoid__term-text installment-factoid__term-text_link cc-link cc-link_wu b",
    attrs: {
      "href": "tel:79882936466"
    }
  }, [_vm._v("\n      +7 (988) 293-64-66\n    ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "installment-factoid__bcg-img-wrap"
  }, [_c('img', {
    staticClass: "installment-factoid__bcg-img",
    attrs: {
      "src": require("./asset/installment-bcg.png"),
      "alt": "фоновое изображение"
    }
  })]);
}]

export { render, staticRenderFns }